import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Column,
  Modal,
  Title,
  IconV2,
} from '@express-labs/raven-ui';
import { cn } from '@express-labs/raven-tools';
import { HeaderDynamicContext } from '../../../../../contexts/HeaderDynamicData/HeaderDynamicData';
import StoreDetails from '../StoreDetails';
import FindStore from '../FindStore';

import s from './ChangeStore.module.scss';

function ChangeStore({ onModalClose }) {
  const { customerStore } = useContext(HeaderDynamicContext);
  return (
    <Modal
      isOpen
      contentLabel="Find in Stores"
      onModalClose={onModalClose}
      setAppElement={document.querySelector('.content')}
      key="markymark"
      className={s.slideout}
    >
      <header className={s.header}>
        <Title tag="h3" className={s.title}>Change Store</Title>
      </header>
      {customerStore?.storeId && (
      <Grid>
        <Column bleed="both" direction="column">
          <section
            className={cn(
              s.container,
              s.bopisStoreItem,
            )}
          >
            <div className={s.yourStore}>
              <span className={s.yourStoreRow}>
                <span className={s.icon}>
                  <IconV2 icon="storePickup" />
                </span>
                <Title tag="h4" className={s.yourStoreTitle}>Selected store pickup location</Title>
              </span>
            </div>
            <StoreDetails
              onModalClose={onModalClose}
              customerStore={customerStore}
            />
          </section>
        </Column>
      </Grid>
      )}
      <FindStore onModalClose={onModalClose} />
    </Modal>
  );
}

ChangeStore.propTypes = {
  onModalClose: PropTypes.func.isRequired,
};

export default ChangeStore;
